import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaLinkedin,
} from "react-icons/fa";

import "./Footer.css";
import Logo from "../../../logotest1.svg";
import NepalHouseIcon from "../../../media/logos/shoppng.png";

const Footer = () => {
  return (
    <footer className="footer text-light py-4">
      <Container>
        <Row className="mb-4">
          {/* Left Section */}
          <Col md={4} className="footer-left">
            <div className="footer-logo">
              <img src={Logo} alt="Company Logo" className="footer-logo-img" />
            </div>
            <div>
              <p>
                From the moment you step through our doors, you will be
                transported to the vibrant and enchanting world of Nepal.
              </p>
            </div>
          </Col>

          {/* Middle Section */}
          <Col md={4} className="footer-middle px-5 pt-5">
            <h5 className="footer-title">Quick Links</h5>
            <ul className="footer-links list-unstyled">
              <li>
                <NavLink to="/" className="footer-link">
                  Home
                </NavLink>
              </li>
              <li>
                <NavLink to="/aboutpage" className="footer-link">
                  About Us
                </NavLink>
              </li>
              <li>
                <NavLink to="/gallery" className="footer-link">
                  Our Products
                </NavLink>
              </li>

              <li>
                <NavLink to="/contact" className="footer-link">
                  Contact Us
                </NavLink>
              </li>
              <li>
                <NavLink to="/newsevent" className="footer-link">
                  News & Event
                </NavLink>
              </li>
            </ul>
          </Col>

          {/* Right Section */}
          <Col md={4} className="footer-right px-5 pt-5">
            <h5 className="footer-title">Follow Us</h5>
            <div className="social-links">
              <a
                href="https://www.facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon"
              >
                <FaFacebookF />
              </a>
              <a
                href="https://www.twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon"
              >
                <FaTwitter />
              </a>
              <a
                href="https://www.instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon"
              >
                <FaInstagram />
              </a>
              <a
                href="https://www.linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon"
              >
                <FaLinkedin />
              </a>
            </div>
            <div className="mt-5">
              <p className="footer-company-name">Nepal Trade House</p>
              <p className="footer-address">
                KapelStraat 15, Bussum, The Netherlands
              </p>
              <p className="footer-phone">Tel: +31357854597</p>
            </div>
          </Col>
        </Row>

        {/* Copyright Section */}
        <Row>
          <Col className="">
            <p className="m-0 powered">
              &copy; {new Date().getFullYear()} Powered By ANRIKA. All rights
              reserved.
            </p>
          </Col>
        </Row>

        {/* Additional Links Section */}
        <Row>
          <Col className="mt-2">
            <p className="footer-useful-links">
              Other useful links:
              <a
                href="https://nepalifecare.org"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-link"
              >
                Nepalifecare.org
              </a>{" "}
              |
              <a
                href="https://diwalipalace.nl"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-link"
              >
                Diwalipalace.nl
              </a>
              |
              <a
                href="https://nepalhouse.org"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-link"
              >
                NepalHouse.org
              </a>
            </p>
          </Col>
        </Row>
      </Container>

      {/* Sticky Bottom Right Icon */}
      <a
        href="https://nepalhouse.org"
        target="_blank"
        rel="noopener noreferrer"
        className="floating-nepalhouse-icon"
      >
        <img src={NepalHouseIcon} alt="Nepal House" />
      </a>
    </footer>
  );
};

export default Footer;